import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@modules/components/auth/auth.service';
import { RouteRedirectService } from '@app/core/services/route-redirect.service';
import { SignupFlowStorageService } from '../services/signup-flow-storage.service';

export const signupFlowAccessGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  if (!authService.isLoggedIn()) {
    return true;
  }

  if (inject(SignupFlowStorageService).readOwn(authService.user?.id ?? null)) {
    return true;
  }

  return inject(RouteRedirectService).getRedirectUrlByRole(
    authService.userRole,
  );
};
